import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Box from '@mui/material/Box'
import Collapse from '@mui/material/Collapse'
import url from 'libraries/front-end-core/core/url'
import MenuItemContainer from 'redux/containers/components/dealwatch/MenuItemContainer'
import selectWindowWidth from 'redux/selectors/selectWindowWidth'
import { MW_LIST_DEALS, MW_ANALYTICS } from 'constants/controllers'
import selectAolName from 'redux/selectors/selectAolName'

const menuItems = [
  { title: 'All Deals', dealType: 'all', label: 'all' },
  { title: 'Public M&A', dealType: 'pma', label: 'pma' },
  { title: 'IPOs', dealType: 'ipo', label: 'ipo' },
  { title: 'Secondary Offers', dealType: 'so', label: 'so' },
  { title: 'Analytics', label: 'analytics' }
]

const getUrl = ({ aol, dealType, searchPhrase }, search) => dealType || search
  ? url(MW_LIST_DEALS, { aol, dealType }, { q: searchPhrase })
  : url(MW_ANALYTICS, { aol })

const DealWatchHeader = props => {
  const [show, setShow] = useState(true)
  const windowWidth = useSelector(selectWindowWidth)
  const aol = useSelector(selectAolName)

  useEffect(() => {
    if (windowWidth > 959) {
      setShow(true)
    }
  }, [setShow, windowWidth])

  return (
    <div className='layout-width-constraint pt6 pt6-t pt4-m pb2 pb0-t pb0-m'>
      <div data-help-item='menu' data-help-position='bottom'>
        <Collapse in={show}>
          <Grid container justifyContent='center' spacing={1} className='pb3'>
            {menuItems.map((item, index) => {
              const { searchPhrase } = props
              const url = getUrl(
                { aol, searchPhrase, dealType: item.dealType },
                item.label !== 'analytics'
              )
              return (
                <Grid key={index} item xs={4} sm={4} md={2}>
                  <MenuItemContainer {...{ ...item, url }} />
                </Grid>
              )
            })}
          </Grid>
        </Collapse>
        <Box sx={{ display: { xs: 'flex', md: 'none' }, justifyContent: 'center' }}>
          <IconButton
            size='small'
            className='bg-white shadow-black-1 mv2'
            onClick={() => setShow(!show)}
          >
            {show ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Box>
      </div>
    </div>
  )
}

export default DealWatchHeader
